import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    ref: "rootRef",
    staticClass: "bannerBox",
    style: {
      padding: "0px " + (_vm.formData.mHorizontalPadding || 0) + "px",
      backgroundColor: _vm.formData.bgColor || "#f7f8fb"
    }
  }, [_vm.formData.pathLink.length == 0 ? _c("img", {
    style: {
      width: "100%",
      height: _vm.formData.mHeight + "px",
      objectFit: "contain"
    },
    attrs: {
      src: _vm.noImg
    }
  }) : _c("div", {
    staticClass: "banner_bg"
  }, [_vm._l(_vm.moduleData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "bg_wrapper",
      style: {
        marginBottom: (_vm.formData.mBannerVerticalSpace || 0) + "px"
      }
    }, _vm._l(item, function (item2, i2) {
      return _c("div", {
        key: i2,
        staticClass: "div_img_bg",
        style: {
          width: item2.outWidth,
          height: item2.height,
          margin: "0 ".concat(item2.padding)
        },
        attrs: {
          "data-index": i2
        }
      }, [_c("div", {
        staticClass: "div_content_bg"
      }, [_c("YYImage", {
        staticClass: "div_banner",
        style: item.style,
        attrs: {
          fit: "cover",
          lazy: false,
          src: _vm.imgHost + item2.imgpath
        }
      }), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()], 1), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()]);
    }), 0);
  })], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };